import React, { ButtonHTMLAttributes } from 'react';
import { IconBaseProps } from 'react-icons';

import { Container } from './styles';

type IconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  icon: React.ComponentType<IconBaseProps>;
};

const IconButton: React.FC<IconButtonProps> = ({ icon: Icon, ...rest }) => {
  return (
    <Container type="button" {...rest}>
      <Icon />
    </Container>
  );
};

export default IconButton;
